const columns = [
  {
    title: "Trigger event",
    dataIndex: "triggerEvent",
  },
  {
    title: "Days after",
    dataIndex: "daysAfter",
  },
  {
    title: "Email template",
    dataIndex: "emailTemplate",
  },
  {
    title: "Stop event",
    dataIndex: "stopEvent",
  },
  {
    title: "Requirements",
    dataIndex: "requirements",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Created Date",
    dataIndex: "createdDate",
  },
  {
    title: "Actions",
    dataIndex: "action",
  },
];

export default columns;
